import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddItemPropertyType = ({ show, onClose, onCreated  }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    // Helper function to convert string to Title Case
      const toTitleCase = (str) => {
        return str
          .toLowerCase()
          .split(' ')
          .filter(Boolean) // Remove empty strings caused by multiple spaces
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      };
    
      // Handle changes in department name and convert to Title Case
      const handleNameChange = (e) => {
        let value = e.target.value;
        value = toTitleCase(value);
        setName(value);
    
        if (value.length <= 300) {
          setNameLengthError('');
        }
        // Clear server-side errors on change
        setErrors(prev => ({ ...prev, propertytype_name: '' }));
      };
    
      // Handle changes in description and convert to Title Case
      const handleDescriptionChange = (e) => {
        let value = e.target.value;
        value = toTitleCase(value);
        setDescription(value);
    
        if (value.length > 500) {
          setDescLengthError('Limit reached (max 500 characters)');
        } else {
          setDescLengthError('');
        }
      };
    
      const handleSubmit = () => {
        // Clear previous errors
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');
    
        // Validation checks
        if (!name.trim()) {
          setErrors({ propertytype_name: 'This field is required' });
          return;
        }
    
        if (name.length > 300) {
          setNameLengthError('Limit reached (max 300 characters)');
          return;
        }
    
        if (description.length > 500) {
          setDescLengthError('Limit reached (max 500 characters)');
          return;
        }
    
        // API call
        axios.post(`${baseURL}/propertytype`, {
          propertytype_name: name,
          description,
        })
        .then(() => {
          onClose();
          if (onCreated) onCreated(); // Refresh list after add
          // window.location.reload();
          toast.success("Property Type Created successfully!");
        })
        .catch(error => { 
          if (error.response?.status === 400) {
            if (error.response.data?.message === 'Property Type already exists') {
              setErrors(prevErrors => ({
                ...prevErrors,
                propertytype_name: 'Property Type with this name already exists'
              }));
            } else if (error.response.data.errors) {
              setErrors(error.response.data.errors);
            }
          } else {
            console.error("Create failed:", error);
            toast.error("Create Failed");
          }
        });
      };
    
 
    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Property Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Property Type<span className="required">*</span></label>
                            <input type="text"  className={`form-control ${errors.propertytype_name ? 'is-invalid' : ''}`} value={name}
                            onChange={handleNameChange} placeholder="Enter Property Type" />
                            {errors.propertytype_name && (
                                    <div className="invalid-feedback d-block">{errors.propertytype_name}</div>
                                )}
                                {nameLengthError && (
                                    <span className="text-danger">{nameLengthError}</span>
                                )}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className={`form-control ${errors.description ? 'is-invalid' : ''}`} name="comment" placeholder="Description" value={description}
                             onChange={handleDescriptionChange} />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Property Type <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddItemPropertyType;
